import { useCurrencySettingsStore, formatCurrency as formatCurrencyWithSettings } from '../stores/currencySettingsStore';

export const useCurrencyFormat = () => {
  const { settings } = useCurrencySettingsStore();

  const formatCurrency = (amount: number): string => {
    return formatCurrencyWithSettings(amount, settings);
  };

  return {
    formatCurrency,
    settings,
  };
};
